function setHtmlSize(){
    // 获取html标签
    const html = document.querySelector('html')
    // 屏幕的宽度除以10，获取跟元素fontSize标准
    let fontSize = window.innerWidth / 100
    // 定义根元素 大小
    html.style.fontSize = fontSize + 'px'
  }
  
  // 监听 HTML 文档被解析完成的事件
  document.addEventListener('DOMContentLoaded', () => {
    setHtmlSize()
  })
  window.addEventListener('resize',()=>{
    setHtmlSize()
  })